import { useQuery } from '@tanstack/react-query';

import { get } from '../../../../../lib/api';

const useGetMessage = (campaignId, messageId, postId) => {
  const {
    data: { message },
    refetch,
  } = useQuery(
    ['message', messageId],
    () =>
      get(
        `/api/client_admin/campaigns/${campaignId}/posts/${postId}/messages/${messageId}`,
      ),
    {
      initialData: {
        message: {
          populationSegmentsOptions: [],
          sendToOptions: [],
          subject: '',
        },
      },
      enabled: false,
    },
  );

  return { message, refetch };
};

export default useGetMessage;
